module.exports = __webpack_public_path__ + "assets/img/qrcode.5d5679f6.jpg";